import { PlusOutlined, SearchOutlined, ClockCircleOutlined, ShoppingCartOutlined, CalendarOutlined, FilterOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Space, Input, Modal, Tabs, Popconfirm, Pagination, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import config from '../../../config';
import MouvClientDetail from '../../mouvement/mouvementClientDetail/MouvClientDetail';
import { useSelector } from 'react-redux';
import ListeCommande7jrs from './ListeCommande7jrs';
import ListeCommandeJour from './ListeCommandeJour';
import CommandesPeriode from './CommandesPeriode';
import RechercheAvancee from './RechercheAvancee';
import CountUp from 'react-countup';
import LivraisonView from '../../livraison/livraisonView/LivraisonView';
import FormCommande from '../formCommande/FormCommande';
import { toast } from 'react-toastify';
import canSeeFinance from '../../../utils/canSeeFinance';
import usePermissions from '../../../hooks/usePermissions';
import { messageErreur } from '../../../components/ndoe/chargement';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeStats, NdoeStatCard,
} from '../../../components/ndoe';
import { buildCommandeColumns, renderCommandeCard } from './commandeShared';
import { subscribeRealtime } from '../../../realtime';

const ListeCommande = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const searchInput = useRef(null);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('start_date');
    const endDate = queryParams.get('end_date');
    const [open, setOpen] = useState(false);
    const [openss, setOpenss] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [idClient, setIdClient] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    const isAdmin = user?.role === 'admin';
    const { can } = usePermissions();
    const peutCloturer = can('commandes.cloturer'); // admin + secrétaire au seed (matrice)
    const showFinance = canSeeFinance(user);
    // ② Montant (attendu/validé) = donnée financière opérationnelle → admin + secrétaire
    // (cohérent avec le prix de vente ; le serveur masque aussi le champ pour les autres).
    const showMontant = user?.role === 'admin' || user?.role === 'secretaire';
    const [rapportMoney, setRapportMoney] = useState([]);
    const [id_commande, setId_commande] = useState('');
    const [openInfo, setOpenInfo] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 15 });
    const [totalItems, setTotalItems] = useState('');
    const [statutSel, setStatutSel] = useState([]);       // ⑨ id_statut sélectionnés (filtre serveur)
    const [statutOptions, setStatutOptions] = useState([]); // options depuis /api/commande/statut
    const [erreurStatuts, setErreurStatuts] = useState(null);
    const [flashIds, setFlashIds] = useState(() => new Set()); // lignes qui viennent d'arriver (surlignage)
    const fetchRef = useRef(null); // pointe toujours vers le dernier fetchData (pour le flux temps réel)
    // Résumé dynamique (14/07) : le bloc KPI suit l'onglet actif. La période est
    // recalculée CÔTÉ SERVEUR (CURDATE()) — on n'envoie qu'une clé whitelistée.
    const [activeTab, setActiveTab] = useState('0');
    const PERIODES = {
      '0': { param: '', label: 'toutes les commandes' },
      '1': { param: 'today', label: "aujourd'hui" },
      '2': { param: '7', label: 'les 7 derniers jours' },
      '3': { param: '30', label: 'les 30 derniers jours' },
      '4': { param: '90', label: 'les 90 derniers jours' },
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
      };

    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>
              Recherche
            </Button>
            <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Supprimer
            </Button>
            <Button type="link" size="small" onClick={() => { confirm({ closeDropdown: false }); setSearchText(selectedKeys[0]); setSearchedColumn(dataIndex); }}>
              Filter
            </Button>
            <Button type="link" size="small" onClick={() => close()}>close</Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
      onFilter: (value, record) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => { if (visible) setTimeout(() => searchInput.current?.select(), 100); },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }} searchWords={[searchText]} autoEscape textToHighlight={text ? text.toString() : ''} />
        ) : (text),
    });

    const handleDelete = async (id) => {
      try {
        await axios.delete(`${DOMAIN}/api/commande/commande/${id}`);
        fetchData(currentPage, pageSize);   // refetch au lieu de recharger toute la page
      } catch (err) {
        console.log(err);
      }
    };

    // Clôture staff (arbitrages 15/07) : solde les paires restantes en retour
    // magasin ; ≥ 1 vente → « Livrée », rien de vendu → « Annulée ». Les blocages
    // (essai/échange en cours, acompte non soldé) remontent en toast explicite.
    const handleCloturer = async (id) => {
      try {
        const { data } = await axios.put(`${DOMAIN}/api/commande/cloturer/${id}`);
        toast.success(data?.message || 'Commande clôturée.');
        fetchData(currentPage, pageSize);
      } catch (err) {
        toast.error(err.response?.data?.error || 'Clôture impossible.');
      }
    };

    const showModal = (e) => { setOpen(true); setIdClient(e); };
    const handInfo = (e) => { setId_commande(e); setOpenInfo(true); };
    const openDetail = (id) => navigate(`/listeDetailView/${id}`);
    const openProducts = (id) => navigate(`/commandes/${id}`);

    const columns = buildCommandeColumns({
      withSearch: getColumnSearchProps,
      onClient: showModal,
      onInfo: handInfo,
      onDelete: handleDelete,
      onCloturer: peutCloturer ? handleCloturer : undefined,
      isAdmin,
      showMontant,
      indexOffset: ((pagination.current || 1) - 1) * (pagination.pageSize || 15),
    });

    const fetchData = async (page = currentPage, size = pageSize) => {
      try {
        const statutParam = statutSel.length ? `&statut=${statutSel.join(',')}` : '';
        const { data } = await axios.get(`${DOMAIN}/api/commande?date_start=${startDate}&date_end=${endDate}&page=${page}&pageSize=${size}${statutParam}`);
        setData(data.data);
        setTotalItems(data.totalItems);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    // ⑨ Changement de statuts : on repart en page 1 (le total change).
    const onStatutChange = (vals) => { setStatutSel(vals); setCurrentPage(1); };

    useEffect(() => {
      fetchData(currentPage, pageSize);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize, statutSel]);

    // Options du filtre statut (Validé / Non-validé…), chargées une fois.
    useEffect(() => {
      axios.get(`${DOMAIN}/api/commande/statut`)
        .then(({ data }) => setStatutOptions(Array.isArray(data) ? data : []))
        .catch((e) => { setStatutOptions([]); setErreurStatuts(messageErreur(e, 'les statuts')); });
    }, [DOMAIN]);

    // Temps réel (R2) : à l'arrivée d'un événement « commande » (création /
    // correction), on rafraîchit la page courante (débounce, pour absorber les
    // rafales) et on surligne brièvement les lignes concernées — la ligne apparaît
    // sans rafraîchir. Le flux SSE est partagé avec la cloche (une seule connexion).
    fetchRef.current = () => { fetchData(currentPage, pageSize); fetchRapport(); };
    useEffect(() => {
      let debounce = null;
      const unsub = subscribeRealtime((payload) => {
        const ids = (payload?.notifications || [])
          .filter((n) => n.entity === 'commande' && n.id_commande)
          .map((n) => Number(n.id_commande));
        if (!ids.length) return;
        setFlashIds((prev) => { const s = new Set(prev); ids.forEach((id) => s.add(id)); return s; });
        clearTimeout(debounce);
        debounce = setTimeout(() => { if (fetchRef.current) fetchRef.current(); }, 600);
        setTimeout(() => {
          setFlashIds((prev) => { const s = new Set(prev); ids.forEach((id) => s.delete(id)); return s; });
        }, 6000);
      });
      return () => { clearTimeout(debounce); unsub(); };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTableChange = (paginationArg) => {
      // Pas de fetchData ici : le useEffect [currentPage, pageSize] s'en charge
      // (l'appel explicite doublait chaque requête à chaque changement de page).
      setCurrentPage(paginationArg.current);
      setPageSize(paginationArg.pageSize);
      setPagination({ current: paginationArg.current, pageSize: paginationArg.pageSize });
    };

    // Résumé (KPI) : suit l'onglet actif (période serveur) en plus des filtres.
    // Hoisté pour être aussi rappelé par le flux temps réel (fetchRef).
    const fetchRapport = async () => {
      try {
        const periode = PERIODES[activeTab]?.param || '';
        // Les dates viennent de l'URL — les MÊMES que celles de la liste
        // (fetchData). Avant, le résumé lisait un état alimenté par l'ancien
        // panneau « Filtres avancés » : liste et résumé pouvaient donc porter
        // sur des périodes DIFFÉRENTES. Le panneau supprimé, ils s'alignent.
        const bornes = `start_date=${startDate || ''}&end_date=${endDate || ''}`;
        const { data } = await axios.get(`${DOMAIN}/api/commande/commandeRapportTopbar?${bornes}&searchValue=${encodeURIComponent(searchValue)}&periode=${periode}`);
        setRapportMoney(data);
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      fetchRapport();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMAIN, startDate, endDate, searchValue, activeTab]);

    const filteredData = data?.filter((item) =>
      item.nom?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.nom_statut?.toLowerCase().includes(searchValue.toLowerCase())
    );

    // ----- Onglet "Commandes" (liste paginée serveur) -----
    const tabAll = (
      <>
        <NdoeToolbar
          search={
            <Input.Search
              type="search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Rechercher (client, statut)…"
              allowClear
              style={{ width: 250 }}
            />
          }
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="Filtrer par statut"
            value={statutSel}
            onChange={onStatutChange}
            options={statutOptions.map((s) => ({ value: s.id_statut, label: s.nom_statut }))}
            // Le menu vide dit POURQUOI il est vide, là où l'on regarde.
            notFoundContent={erreurStatuts || undefined}
            style={{ minWidth: 180 }}
            maxTagCount="responsive"
          />
          {/* FUSION (16/07) : le bouton « Filtres avancés » a été RETIRÉ. Il
              dépliait un vieux panneau de dates, et son nom était si proche de
              l'onglet « Recherche avancée » que le proprio y cherchait ses
              critères sans les trouver. Un seul outil désormais : l'onglet
              Recherche (2ᵉ position), qui fait tout ce que faisait ce panneau
              — plage de dates libre — et bien plus. */}
        </NdoeToolbar>

        <NdoeResponsiveTable
          data={filteredData}
          columns={columns}
          rowKey="id_commande"
          loading={loading}
          onRow={(record) => ({ className: flashIds.has(Number(record.id_commande)) ? 'ndoe-row-flash' : '' })}
          scroll={{ x: 'max-content' }}
          pagination={{ current: currentPage, pageSize, total: Number(totalItems) || 0 }}
          onChange={handleTableChange}
          renderCard={(record) => renderCommandeCard(record, {
            onOpen: openDetail, onProducts: openProducts, onDelete: handleDelete,
            onCloturer: peutCloturer ? handleCloturer : undefined, isAdmin, showMontant,
          })}
          empty={{ icon: '🧾', title: 'Aucune commande', text: 'Ajustez la recherche ou les filtres.' }}
          mobilePager={
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={Number(totalItems) || 0}
                showSizeChanger={false}
                onChange={(p, s) => handleTableChange({ current: p, pageSize: s })}
              />
            </div>
          }
        />
      </>
    );

    const tabItems = [
      { key: '0', label: <span><ShoppingCartOutlined />Commandes</span>, children: tabAll },
      // La Recherche est un OUTIL, pas une période : sa place est ici, pas au
      // bout d'une file d'onglets de durées. Reléguée en 6ᵉ position (après
      // l'ajout de 30j/90j), le proprio ne la trouvait plus.
      { key: '5', label: <span><SearchOutlined />Recherche</span>, children: <RechercheAvancee /> },
      { key: '1', label: <span><CalendarOutlined />Du jour</span>, children: <ListeCommandeJour /> },
      { key: '2', label: <span><ClockCircleOutlined />7 derniers jours</span>, children: <ListeCommande7jrs /> },
      { key: '3', label: <span><ClockCircleOutlined />30 derniers jours</span>, children: <CommandesPeriode endpoint="commandePeriode?jours=30" emptyText="Aucune commande sur les 30 derniers jours." /> },
      { key: '4', label: <span><ClockCircleOutlined />90 derniers jours</span>, children: <CommandesPeriode endpoint="commandePeriode?jours=90" emptyText="Aucune commande sur les 90 derniers jours." /> },
    ];

  return (
    <NdoePage>
      {/* Pas de <ToastContainer/> ici : App.js:836 en monte déjà un, global et
          porteur du correctif WebView (#147). Un second conteneur ÉTEIGNAIT
          les messages de TOUTE l'application — react-toastify 10.0.5 indexe
          ses conteneurs sur `containerId || 1` (react-toastify.esm.mjs), donc
          deux conteneurs sans containerId se battent pour la clé 1 : celui-ci
          écrasait celui d'App, puis son démontage faisait `delete(1)`, laissant
          le registre VIDE. Le conteneur d'App restait affiché mais désinscrit,
          et chaque toast partait dans une file d'attente invisible — recrachée
          d'un bloc au retour sur cette page. */}
      <NdoePageHeader
        eyebrow="Commerce"
        title="Liste des commandes"
        subtitle="Gérez et suivez toutes vos commandes"
        actions={
          <NdoeActionButton variant="primary" icon={<PlusOutlined />} onClick={() => setOpenss(true)}>
            Nouvelle commande
          </NdoeActionButton>
        }
      />

      {/* Le résumé suit l'onglet actif (période) — la légende dit laquelle. */}
      <div style={{ fontSize: 12.5, color: '#8a94a6', margin: '0 0 6px', fontWeight: 600 }}>
        Résumé : {PERIODES[activeTab]?.label || 'toutes les commandes'}
      </div>
      <NdoeStats>
        <NdoeStatCard label="En attente" value={<CountUp end={Number(rapportMoney?.commande_Enattente) || 0} />} />
        <NdoeStatCard label="En cours" value={<CountUp end={Number(rapportMoney?.commande_Encours) || 0} />} />
        <NdoeStatCard label="Livrées" value={<CountUp end={Number(rapportMoney?.commande_livre) || 0} />} />
        <NdoeStatCard label="Total commandes" value={<CountUp end={Number(rapportMoney?.nbre_commande) || 0} />} />
        <NdoeStatCard label="Articles" value={<CountUp end={Number(rapportMoney?.nbre_articles) || 0} />} />
        {showFinance && (
          <NdoeStatCard gold label="Montant ventes" value={<><CountUp end={Number(rapportMoney?.montant_total) || 0} /> $</>} />
        )}
      </NdoeStats>

      <Tabs type="card" items={tabItems} activeKey={activeTab} onChange={setActiveTab} />

      {/* Modales */}
      <Modal title="Information de client" centered open={open} onCancel={() => setOpen(false)} width={850} footer={[]}>
        <MouvClientDetail idClients={idClient} />
      </Modal>

      <Modal title="" centered open={openInfo} onCancel={() => setOpenInfo(false)} width={1000} footer={[]}>
        <LivraisonView id={id_commande} />
      </Modal>

      {/* destroyOnClose : sans lui, fermer par X laissait FormCommande monté
          caché avec ses saisies → la garde « formulaire modifié » (useFormGuard)
          bloquait le retour et beforeunload pour un formulaire invisible
          (constat revue #97). */}
      <Modal title="" centered open={openss} onCancel={() => setOpenss(false)} width={1000} footer={[]} destroyOnClose>
        <FormCommande fetchData={fetchData} closeModal={() => setOpenss(false)} />
      </Modal>
    </NdoePage>
  )
}

export default ListeCommande
